export const ITEM_MULTIPLY_OPACITY_MIN = 0;
export const ITEM_MULTIPLY_OPACITY_DISPLAY_MIN = 0;
export const ITEM_MULTIPLY_OPACITY_MAX = 1;
export const ITEM_MULTIPLY_OPACITY_DISPLAY_MAX = 100;
